export default function hasSimpleImageFileExtension(filename){


  let simpleUploadExtensions = ['png','jpg','jpeg','webp']

  let filenameExt = filename.split('.').slice(-1)[0]
  let isMultidimUpload = !simpleUploadExtensions.includes(filenameExt);


  return !isMultidimUpload;



}
